import { HandCoins } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "./Reveal";

export default function GiveBand() {
  const give = () =>
    toast.info("Online giving is coming soon", {
      description: "Until then, you can give in person during any service. Thank you for your generosity!",
    });

  return (
    <section data-testid="give-band" className="relative py-28 md:py-36 bg-[#4169E1] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-wrap items-center justify-between gap-10">
        <Reveal>
          <h2 className="font-display font-bold uppercase tracking-tighter leading-none text-4xl sm:text-5xl md:text-6xl">
            Sow into the vision
          </h2>
          <p className="mt-4 text-base md:text-lg text-white/80 max-w-xl">
            Your generosity fuels the work of reaching, teaching, and empowering in Jackson and beyond.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <button
            data-testid="give-band-button"
            onClick={give}
            className="inline-flex items-center gap-3 bg-black text-white font-semibold uppercase tracking-widest text-sm px-10 py-5 rounded-sm transition-colors duration-300 hover:bg-[#111] hover:-translate-y-0.5"
          >
            <HandCoins className="w-5 h-5" />
            Give Online
          </button>
        </Reveal>
      </div>
    </section>
  );
}
